import Swiper from "swiper/bundle";

export class Cart {
  root = window.Shopify.routes.root;
  sections = "cart-template,cart-aside,header";
  useCartAside = false;
  giftData = null;

  constructor() {
    const $body = document.querySelector("body");
    this.useCartAside = $body.dataset?.useCartAside === "true" ? true : false;

    const scriptTag = document.querySelector(".cart-aside__json");
    if (scriptTag) {
      const jsonText = scriptTag?.textContent;
      const data = JSON.parse(jsonText);
      this.giftData = data;
    }
  }

  // these functions are used to re-render
  reRenderHeader = ($header, newSectionText) => {
    // Get the text of the new section and render it to a div thats not in the DOM
    const $newSection = document.createElement("div");
    $newSection.innerHTML = newSectionText;
    const $newHeader = $newSection.querySelector("header.header");

    // Set the desktop cart link to the new sections desktop cart link
    const $currentDesktopCartLink = $header.querySelector(
      ".navbar__desktop .header__cart-link"
    );
    const $newDesktopCartLink = $newHeader.querySelector(
      ".navbar__desktop .header__cart-link"
    );
    $currentDesktopCartLink.innerHTML = $newDesktopCartLink.innerHTML;

    // // Set the mobile cart link to the new sections mobile cart link
    // const $currentMobileCartLink = $header.querySelector(
    //   ".navbar__mobile .header__cart-link"
    // );
    // const $newMobileCartLink = $newHeader.querySelector(
    //   ".navbar__mobile .header__cart-link"
    // );
    // $currentMobileCartLink.innerHTML = $newMobileCartLink.innerHTML;

    // // Set the Mobile Menu cart link to the new sections mobile menu cart link
    // const $currentMobileMenuCartLink = $header.querySelector(
    //   ".menu__mobile .menu__cart"
    // );
    // const $newMobileMenuCartLink = $newHeader.querySelector(
    //   ".menu__mobile .menu__cart"
    // );
    // $currentMobileMenuCartLink.innerHTML = $newMobileMenuCartLink.innerHTML;

    // // Set the navbar cart popout to the new sections navbar cart popout
    // const $currentNavbarCart = $header.querySelector(".nav__bar-cart");
    // const $newNavbarCart = $newHeader.querySelector(".nav__bar-cart");
    // $currentNavbarCart.innerHTML = $newNavbarCart.innerHTML;
  };

  addLineItemEventListeners = ($lineItem, type) => {
    const key = $lineItem.dataset.key;
    const productId = $lineItem.dataset.productId;
    const variantId = $lineItem.dataset.variantId;
    const sellingPlanId = $lineItem.dataset.sellingPlanId;
    const quantity = $lineItem.dataset.quantity;
    const $lineItemQuantitys = $lineItem.querySelectorAll(
      ".line-item__quantity"
    );

    // Loop through the line items quantity controlls and add the event listeners
    $lineItemQuantitys.forEach(($lineItemQuantity) => {
      const $lineItemQuantityDecrease = $lineItemQuantity.querySelector(
        ".line-item__quantity-decrease"
      );
      const $lineItemQuantityValue = $lineItemQuantity.querySelector(
        ".line-item__quantity-value"
      );
      const $lineItemQuantityIncrease = $lineItemQuantity.querySelector(
        ".line-item__quantity-increase"
      );

      // Add the decrease evetn listeners
      $lineItemQuantityDecrease.addEventListener("click", async (event) => {
        event.preventDefault();
        const quantity = parseInt($lineItemQuantityValue.textContent);
        if (quantity > 0) {
          const decreaseResponse = await this.updateLineItemQuantity(
            key,
            parseInt(quantity) - 1
          );
          if (decreaseResponse && decreaseResponse.sections) {
            this.reRenderSections(decreaseResponse.sections);
          }
        }
      });

      //add the increase event listeners
      $lineItemQuantityIncrease.addEventListener("click", async (event) => {
        event.preventDefault();
        const increaseResponse = await this.updateLineItemQuantity(
          key,
          parseInt($lineItemQuantityValue.textContent) + 1
        );
        if (increaseResponse && increaseResponse.sections) {
          this.reRenderSections(increaseResponse.sections);
        }
      });
    });

    // Loop through the line items remove buttons and add the event listeners
    const $lineItemRemove = $lineItem.querySelectorAll(".line-item__remove");
    $lineItemRemove.forEach(($element) => {
      $element.addEventListener("click", async (event) => {
        event.preventDefault();
        const removeResponse = await this.removeLineItemFromCart(key);
        // this.reRenderSections(removeResponse.sections);
      });
    });

    const $lineItemUpgrade = $lineItem.querySelector(".line-item__upgrade");
    if ($lineItemUpgrade) {
      $lineItemUpgrade.addEventListener("click", (event) => {
        event.preventDefault();
        this.addSubscription(
          $lineItemUpgrade.dataset.key,
          $lineItemUpgrade.dataset.variantId,
          parseInt($lineItemUpgrade.dataset.quantity),
          $lineItemUpgrade.dataset.sellingPlan
        );
      });
    }

    // // Add the onetime and subscription button event listeners
    // const $lineItemPurchaseTypes = $lineItem.querySelector(
    //   ".line-item__purchase-types"
    // );
    // if ($lineItemPurchaseTypes) {
    //   const $onetimeButton = $lineItemPurchaseTypes.querySelector(
    //     ".purchase-type__button.purchase-type__button--onetime"
    //   );
    //   if (!$onetimeButton.classList.contains("purchase-type__button--active")) {
    //     $onetimeButton.addEventListener("click", (event) => {
    //       event.preventDefault();
    //       this.removeSubscription(key, variantId, quantity);
    //     });
    //   }

    //   const $subscriptionButton = $lineItemPurchaseTypes.querySelector(
    //     ".purchase-type__button.purchase-type__button--subscription"
    //   );

    //   if (
    //     !$subscriptionButton.classList.contains("purchase-type__button--active")
    //   ) {
    //     $subscriptionButton.addEventListener("click", (event) => {
    //       event.preventDefault();
    //       this.addSubscription(key, variantId, quantity, sellingPlanId);
    //     });
    //   }
    // }

    // Add the subscription plan select event listeners
    const $subscriptionSelect = $lineItem.querySelector(
      ".line-item__subscription-select"
    );
    if ($subscriptionSelect) {
      $subscriptionSelect.addEventListener("change", (event) => {
        event.preventDefault();
        this.addSubscription(key, variantId, quantity, event.target.value);
      });
    }
  };

  setUpCartTemplate = ($cartTemplate) => {
    /* 
      Find the line items in the cart tempalte and if they exist loop through and
      add the events listners
    */
    const $lineItemsContainer = $cartTemplate.querySelector(
      ".cart-template__line-items"
    );
    if ($lineItemsContainer) {
      const $lineItems = $lineItemsContainer.querySelectorAll(
        ".cart-template__line-item"
      );
      $lineItems.forEach(($lineItem) => {
        this.addLineItemEventListeners($lineItem, "template");
      });

      const $clearCarts = $cartTemplate.querySelectorAll(
        ".cart-template__clear"
      );
      $clearCarts.forEach(($clearCart) => {
        $clearCart.addEventListener("click", (event) => {
          event.preventDefault();
          this.clearCart();
        });
      });
    }

    const $mobileDeliveryButton = $cartTemplate.querySelector(
      ".cart-template__delivery.cart-template__delivery--mobile"
    );
    const $mobileDeliveryPopup = $cartTemplate.querySelector(
      ".cart-template__delivery-popup.cart-template__delivery-popup--mobile"
    );
    if ($mobileDeliveryButton && $mobileDeliveryButton) {
      $mobileDeliveryPopup.addEventListener("click", (event) => {
        if (event.target == $mobileDeliveryPopup) {
          $mobileDeliveryPopup.classList.add(
            "opacity-0",
            "pointer-events-none"
          );
        }
      });
      $mobileDeliveryButton.addEventListener("click", (event) => {
        event.preventDefault();
        $mobileDeliveryPopup.classList.remove(
          "opacity-0",
          "pointer-events-none"
        );
      });
    }
  };

  reRenderCartTemplate = ($element, newSectionText) => {
    // Get the text of the new section and render it to a div thats not in the DOM
    const $newSection = document.createElement("div");
    $newSection.innerHTML = newSectionText;

    const $currentTemplateContainer = $element.querySelector(
      ".cart-template__container"
    );
    const $newTemplateContainer = $newSection.querySelector(
      ".cart-template__container"
    );

    if (
      $currentTemplateContainer.classList.contains(
        "cart-template__container--empty"
      ) ||
      $newTemplateContainer.classList.contains(
        "cart-template__container--empty"
      )
    ) {
      // If either the new or old cart is empty repalce the entire cart
      $currentTemplateContainer.innerHTML = $newTemplateContainer.innerHTML;
    } else {
      // Set the current line items to the new line items
      const $currentLineItems = $currentTemplateContainer.querySelector(
        ".cart-template__line-items"
      );
      const $newLineItems = $newTemplateContainer.querySelector(
        ".cart-template__line-items"
      );

      if ($currentLineItems && $newLineItems) {
        $currentLineItems.innerHTML = $newLineItems.innerHTML;
      }

      // Set the current sumamry to the new summmary
      const $currentSummary = $currentTemplateContainer.querySelector(
        ".cart-template__summary"
      );
      const $newSummary = $newTemplateContainer.querySelector(
        ".cart-template__summary"
      );

      if ($currentSummary && $newSummary) {
        $currentSummary.innerHTML = $newSummary.innerHTML;
      }
    }

    // Set the cart template  to the new cart template
    const $newCartTemplate = $newSection.querySelector(".cart-template");
    $element.innerHTML = $newCartTemplate.innerHTML;

    this.setUpCartTemplate($element);
  };

  setUpCartAside = ($cartAside) => {
    /* 
      Find the line items in the cart aside and if they exist loop through and
      add the events listners
    */
    const $lineItemsContainer = $cartAside.querySelector(
      ".cart-aside__line-items"
    );
    if ($lineItemsContainer) {
      const $lineItems = $lineItemsContainer.querySelectorAll(
        ".cart-aside__line-item"
      );
      $lineItems.forEach(($lineItem) => {
        this.addLineItemEventListeners($lineItem, "aside");
      });

      const $recomendedItem = $cartAside.querySelector(
        ".cart-aside__recommended-item"
      );
      if ($recomendedItem) {
        const $recomendedItemAdd = $recomendedItem.querySelector(
          ".recommended-item__add"
        );

        $recomendedItemAdd?.addEventListener("click", (event) => {
          event.preventDefault();
          const productId = $recomendedItem.dataset.productId;
          const variantId = $recomendedItem.dataset.variantId;
          this.quickAddItemToCart(variantId);
        });
      }
    }

    const $cartAsideDeliveryNote = $cartAside.querySelector(
      ".cart-aside__delivery-note"
    );
    const $deliveryNoteButton = $cartAsideDeliveryNote.querySelector(
      ".delivery-note__button"
    );
    const $buttonIcon = $deliveryNoteButton.querySelector(".button__icon");
    const $iconUnticked = $buttonIcon.querySelector(".icon__unticked");
    const $iconTicked = $buttonIcon.querySelector(".icon__ticked");

    const $deliveryNoteTextarea = $cartAsideDeliveryNote.querySelector(
      ".delivery-note__textarea"
    );

    $deliveryNoteButton.addEventListener("click", async (event) => {
      event.preventDefault();

      if (
        $cartAsideDeliveryNote.classList.contains(
          "cart-aside__delivery-note--active"
        )
      ) {
        $iconUnticked.classList.remove("hidden");
        $iconTicked.classList.add("hidden");

        $deliveryNoteTextarea.classList.add("hidden");
        $deliveryNoteTextarea.dataset.value = $deliveryNoteTextarea.value;
        $deliveryNoteTextarea.value = "";
        $cartAsideDeliveryNote.classList.remove(
          "cart-aside__delivery-note--active"
        );

        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ note: "" }),
        });
      } else {
        $iconTicked.classList.remove("hidden");
        $iconUnticked.classList.add("hidden");

        $deliveryNoteTextarea.classList.remove("hidden");
        if ($deliveryNoteTextarea.dataset.value) {
          $deliveryNoteTextarea.value = $deliveryNoteTextarea.dataset.value;
        } else {
          $deliveryNoteTextarea.value = "";
        }
        $cartAsideDeliveryNote.classList.add(
          "cart-aside__delivery-note--active"
        );
      }
    });

    const $cartAsideRecommendedItems = $cartAside.querySelector(
      ".cart-aside__recommended-items"
    );
    if ($cartAsideRecommendedItems) {
      const $recomendedItemProductCards =
        $cartAsideRecommendedItems.querySelectorAll(
          ".cart-aside__recommended-item"
        );
      $recomendedItemProductCards.forEach(($recomendedItemProductCard) => {
        const $recomendedItemVariantSelect =
          $recomendedItemProductCard.querySelector(
            ".recommended-item__variant-select"
          );

        $recomendedItemVariantSelect?.addEventListener("change", (event) => {
          event.preventDefault();
          $recomendedItemProductCard.dataset.variantId = event.target.value;
        });

        const $recommendedItemAddToCarts =
          $recomendedItemProductCard.querySelectorAll(
            ".recommended-item__add-to-cart"
          );
        $recommendedItemAddToCarts.forEach(($recommendedItemAddToCart) => {
          $recommendedItemAddToCart?.addEventListener("click", (event) => {
            event.preventDefault();
            this.addItemToCart(
              $recomendedItemProductCard.dataset.variantId,
              parseInt($recomendedItemProductCard.dataset.quantity),
              $recomendedItemProductCard.dataset.sellingPlanId
            );
          });
        });
      });

      const $recomendedItemsSwiper = $cartAsideRecommendedItems.querySelector(
        ".recommended-items__swiper"
      );
      if ($recomendedItemsSwiper) {
        const recomendedSwiper = new Swiper($recomendedItemsSwiper, {
          slidesPerView: 1,
          spaceBetween: 32,
          navigation: {
            nextEl: ".recommended-items__next",
            prevEl: ".recommended-items__prev",
          },
        });
      }
    }

    const $cartAsideCheckout = $cartAside.querySelector(
      ".cart-aside__checkout"
    );
    $cartAsideCheckout.addEventListener("click", async (event) => {
      event.preventDefault();
      if ($deliveryNoteTextarea.value != "") {
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ note: $deliveryNoteTextarea.value ?? "" }),
        });
      }

      window.location = "/checkout";
    });
  };

  reRenderCartAside = ($element, newSectionText) => {
    // Get the text of the new section and render it to a div thats not in the DOM
    const $newSection = document.createElement("div");
    $newSection.innerHTML = newSectionText;
    const $newCartAside = $newSection.querySelector(".cart-aside");

    const $currentAsideContainer = $element.querySelector(
      ".cart-aside__container"
    );
    const $newAsideContainer = $newCartAside.querySelector(
      ".cart-aside__container"
    );

    if (
      $currentAsideContainer.classList.contains(
        "cart-aside__container--empty"
      ) &&
      !$newAsideContainer.classList.contains("cart-aside__container--empty")
    ) {
      $currentAsideContainer.innerHTML = $newAsideContainer.innerHTML;
      $currentAsideContainer.classList.remove("cart-aside__container--empty");
    } else if (
      $newAsideContainer.classList.contains("cart-aside__container--empty") &&
      !$currentAsideContainer.classList.contains("cart-aside__container--empty")
    ) {
      $currentAsideContainer.innerHTML = $newAsideContainer.innerHTML;
      $currentAsideContainer.classList.add("cart-aside__container--empty");
    } else {
      // Set the current line items to the new line items
      const $currentLineItems = $currentAsideContainer.querySelector(
        ".cart-aside__line-items"
      );
      const $newLineItems = $newAsideContainer.querySelector(
        ".cart-aside__line-items"
      );

      if ($currentLineItems && $newLineItems) {
        $currentLineItems.innerHTML = $newLineItems.innerHTML;
      }

      const $currentFreePostage = $currentAsideContainer.querySelector(
        ".cart-aside__free-postage"
      );
      const $newFreePostage = $newAsideContainer.querySelector(
        ".cart-aside__free-postage"
      );
      if ($currentFreePostage && $newFreePostage) {
        $currentFreePostage.innerHTML = $newFreePostage.innerHTML;
      }

      const $currentRecomended = $currentAsideContainer.querySelector(
        ".cart-aside__recommended-items"
      );
      const $newFreeRecomended = $newAsideContainer.querySelector(
        ".cart-aside__recommended-items"
      );
      if ($currentRecomended && $newFreeRecomended) {
        $currentRecomended.innerHTML = $newFreeRecomended.innerHTML;
        $currentRecomended.classList.value = $newFreeRecomended.classList.value;
      }

      // Set the cart aside footer to the new cart aside footer
      const $currentFooter = $element.querySelector(".cart-aside__footer");
      const $newFooter = $newCartAside.querySelector(".cart-aside__footer");

      if ($currentFooter && $newFooter) {
        $currentFooter.innerHTML = $newFooter.innerHTML;
      }
    }

    this.setUpCartAside($element);
  };

  reRenderSections = (sections) => {
    // Check if sections exists before trying to access it
    if (!sections) {
      console.warn('Cart response did not include sections data');
      return;
    }

    const $header = document.querySelector("header.header");
    if ($header && sections["header"]) {
      this.reRenderHeader($header, sections["header"]);
    }

    const $cartAside = document.querySelector("aside.cart-aside");
    if ($cartAside && sections["cart-aside"]) {
      this.reRenderCartAside($cartAside, sections["cart-aside"]);
    }

    const $cartTemplate = document.querySelector("section.cart-template");
    if ($cartTemplate && sections["cart-template"]) {
      this.reRenderCartTemplate($cartTemplate, sections["cart-template"]);
    }

    if (window?.loyaltylion?.ui?.refresh) {
      window.loyaltylion.ui.refresh();
    }
  };

  // The following functions are used to update/get the cart

  updateLineItemQuantity = async (key, quantity) => {
    if (key) {
      // Try to get the current cart to verify the key format
      try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        // Check if the key exists in the cart
        let lineItem = cartData.items.find(item => item.key === key);

        // If not found by exact key, try to find by variant ID (for Givy items)
        if (!lineItem) {
          const variantId = key.split(':')[0]; // Extract variant ID from composite key
          lineItem = cartData.items.find(item => item.variant_id == variantId);
        }

        if (!lineItem) {
          console.error('Line item key not found in cart for quantity update:', key);
          return null;
        } else {
          // Use the actual key from the cart
          key = lineItem.key;
        }
      } catch (error) {
        console.error('Failed to fetch cart data for quantity update:', error);
      }

      const requestJson = {
        id: key,
        quantity: parseInt(quantity),
        sections: this.sections,
      };

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });

      if (!response.ok) {
        console.error('Failed to update line item quantity:', response.status, response.statusText);
        try {
          const errorData = await response.json();
          console.error('Error response:', errorData);
        } catch (e) {
          console.error('Could not parse error response');
        }
        return null;
      }

      const json = await response.json();
      if (json && json.sections) {
        this.reRenderSections(json.sections);
      }
      return json;
    } else {
      return null;
    }
  };

  removeLineItemFromCart = async (key) => {
    if (key) {
      // Try to get the current cart to verify the key format
      try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        // Check if the key exists in the cart
        let lineItem = cartData.items.find(item => item.key === key);

        // If not found by exact key, try to find by variant ID (for Givy items)
        if (!lineItem) {
          const variantId = key.split(':')[0]; // Extract variant ID from composite key
          lineItem = cartData.items.find(item => item.variant_id == variantId);
        }

        if (!lineItem) {
          console.error('Line item key not found in cart:', key);
          return null;
        } else {
          // Use the actual key from the cart
          key = lineItem.key;
        }
      } catch (error) {
        console.error('Failed to fetch cart data:', error);
      }

      const requestJson = {
        id: key,
        quantity: 0,
        sections: this.sections,
      };

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });

      if (!response.ok) {
        console.error('Failed to remove line item:', response.status, response.statusText);
        try {
          const errorData = await response.json();
          console.error('Error response:', errorData);
        } catch (e) {
          console.error('Could not parse error response');
        }
        return null;
      }

      const json = await response.json();

      if (
        json && json.items && json.items.length == 1 &&
        (this.giftData?.enable_oneoff_free_gift ||
          this.giftData?.enable_subscription_free_gift ||
          this.giftData?.enable_order_free_gift)
      ) {
        let removeGiftKey = "";

        json.items.forEach((item) => {
          if (
            (this.giftData?.enable_order_free_gift &&
              this.giftData?.ordergift?.product_variant.id != "" &&
              item.variant_id ==
              this.giftData?.ordergift?.product_variant.id) ||
            (this.giftData?.enable_subscription_free_gift &&
              this.giftData?.subscription_gift?.product_variant.id != "" &&
              item.variant_id ==
              this.giftData?.subscription_gift?.product_variant.id) ||
            (this.giftData?.enable_oneoff_free_gift &&
              this.giftData?.oneoff_gift?.product_variant.id != "" &&
              item.variant_id == this.giftData?.oneoff_gift?.product_variant.id)
          ) {
            removeGiftKey = item.key;
          }
        });

        if (removeGiftKey != "") {
          const giftRequestJson = {
            id: removeGiftKey,
            quantity: 0,
            sections: this.sections,
          };

          const giftResponse = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(giftRequestJson),
          });
          const giftJson = await giftResponse.json();

          if (giftJson && giftJson.sections) {
            this.reRenderSections(giftJson.sections);
          }
        } else {
          if (json && json.sections) {
            this.reRenderSections(json.sections);
          }
        }
      } else {
        if (json && json.sections) {
          this.reRenderSections(json.sections);
        }
      }

      return json;
    } else {
      return null;
    }
  };

  clearCart = async () => {
    const requestJson = {
      sections: this.sections,
    };
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestJson),
    });

    if (!response.ok) {
      console.error('Failed to clear cart:', response.status, response.statusText);
      return null;
    }

    const json = await response.json();
    if (json && json.sections) {
      this.reRenderSections(json.sections);
    }
    return json;
  };

  addItemToCart = async (variantId, quantity, sellingPlanId = null) => {
    if (variantId !== undefined && Number.isInteger(quantity)) {
      const itemObject = {
        id: variantId,
        quantity: quantity,
      };

      if (sellingPlanId) {
        itemObject.selling_plan = sellingPlanId;
      }

      const requestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });
      if (response.ok) {
        const json = await response.json();
        if (
          this.giftData?.enable_oneoff_free_gift ||
          this.giftData?.enable_subscription_free_gift ||
          this.giftData?.enable_order_free_gift
        ) {
          const cartResponse = await fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const cartJson = await cartResponse.json();

          let oneoffCount = 0;
          let oneoffValue = 0;

          let subscriptionCount = 0;
          let subscriptionValue = 0;

          let totalCount = 0;
          let totalValue = 0;

          let giftRequestId = null;

          cartJson.items.forEach((item) => {
            if (item?.selling_plan_allocation) {
              subscriptionCount += parseInt(item.quantity);
              subscriptionValue += parseInt(item.final_line_price);
            } else {
              oneoffCount += parseInt(item.quantity);
              oneoffValue += parseInt(item.final_line_price);
            }

            totalCount += parseInt(item.quantity);
            totalValue += parseInt(item.final_line_price);
          });

          if (
            this.giftData?.enable_order_free_gift &&
            this.giftData?.ordergift?.product_variant?.id != "" &&
            parseInt(this.giftData.ordergift_threshold) >= 0 &&
            totalValue >= parseInt(this.giftData.ordergift_threshold)
          ) {
            giftRequestId = this.giftData?.ordergift?.product_variant?.id;
          } else if (
            this.giftData?.enable_subscription_free_gift &&
            this.giftData?.subscription_gift?.product_variant?.id != "" &&
            parseInt(this.giftData.subscription_gift_threshold) >= 0 &&
            totalValue >= parseInt(this.giftData.subscription_gift_threshold) &&
            subscriptionCount > 0 &&
            sessionStorage.getItem("gtm-reactivate") != "true"
          ) {
            giftRequestId =
              this.giftData?.subscription_gift?.product_variant?.id;
          } else if (
            this.giftData?.enable_oneoff_free_gift &&
            this.giftData?.oneoff_gift?.product_variant?.id != "" &&
            parseInt(this.giftData.oneoff_gift_threshold) >= 0 &&
            totalValue >= parseInt(this.giftData.oneoff_gift_threshold) &&
            oneoffCount > 0
          ) {
            giftRequestId = this.giftData?.oneoff_gift?.product_variant?.id;
          }

          let giftInCart = false;
          cartJson.items.forEach((item) => {
            if (parseInt(item.variant_id) == parseInt(giftRequestId)) {
              giftInCart = true;
            }
          });

          if (giftRequestId && giftInCart == false) {
            const giftResponse = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: giftRequestId,
                    quantity: 1,
                  },
                ],
                sections: this.sections,
              }),
            });
            const giftJson = await giftResponse.json();

            this.reRenderSections(giftJson.sections);
            return giftJson;
          } else {
            this.reRenderSections(json.sections);
            return json;
          }
        } else {
          this.reRenderSections(json.sections);
          return json;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  quickAddItemToCart = async (variantId) => {
    if (variantId !== undefined) {
      const itemObject = {
        id: variantId,
        quantity: 1,
      };

      const requestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });
      if (response.ok) {
        const json = await response.json();
        this.reRenderSections(json.sections);
        return json;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  getCart = async () => {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return null;
    }
  };

  removeSubscription = async (key, variantId, quantity) => {
    if (key) {
      // Remove the subscription from the cart
      const removeRequestJson = {
        id: key,
        quantity: 0,
      };
      const removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(removeRequestJson),
      });

      const itemObject = {
        id: variantId,
        quantity: quantity,
      };
      const addRequestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addRequestJson),
      });
      const json = await addResponse.json();
      this.reRenderSections(json.sections);
    }
  };

  addSubscription = async (key, variantId, quantity, sellingPlanId) => {
    if (key) {
      // Remove the subscription from the cart
      const removeRequestJson = {
        id: key,
        quantity: 0,
      };
      const removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(removeRequestJson),
      });

      const itemObject = {
        id: variantId,
        quantity: quantity,
        selling_plan: sellingPlanId,
      };
      const addRequestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addRequestJson),
      });
      const json = await addResponse.json();
      this.reRenderSections(json.sections);
    }
  };
}

export default Cart;
